import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles(theme => ({
  root: {
    marginTop: theme.spacing(3),
    width: '100%',
    overflow: 'visible',
    padding: '0.05px',
    position: 'relative',
  },
  title: {
    margin: theme.spacing(2),
  },
  leftIcon: {
    marginRight: theme.spacing(1),
  },
  button: {
    marginRight: '5px',
  },
  buttonGroup: {
    position: 'absolute',
    right: '15px',
    top: '15px',
  },
  comboBox: {
    minWidth: '300px',
  },
}));

export default useStyles;
